import { render, staticRenderFns } from "./mini-footer.vue?vue&type=template&id=07825136"
import script from "./mini-footer.vue?vue&type=script&lang=js"
export * from "./mini-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports